module.exports = __webpack_public_path__ + "front/img/b46.dd2c3886.jpg";